import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=4dcb4ab4&scoped=true&"
import script from "./talk.vue?vue&type=script&lang=js&"
export * from "./talk.vue?vue&type=script&lang=js&"
import style0 from "./talk.vue?vue&type=style&index=0&id=4dcb4ab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb4ab4",
  null
  
)

export default component.exports